// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-jsx": () => import("./../../../src/pages/404.jsx" /* webpackChunkName: "component---src-pages-404-jsx" */),
  "component---src-pages-index-jsx": () => import("./../../../src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */),
  "component---src-pages-inventory-history-jsx": () => import("./../../../src/pages/inventory/history.jsx" /* webpackChunkName: "component---src-pages-inventory-history-jsx" */),
  "component---src-pages-inventory-index-jsx": () => import("./../../../src/pages/inventory/index.jsx" /* webpackChunkName: "component---src-pages-inventory-index-jsx" */)
}

